// @flow
import React from 'react';
import { connect } from 'react-redux';
import TextTransformer from 'app/common/react/components/common/TextTransformer/TextTransformer';
import type { CarouselPinData } from 'app/packages/pinterest-flow-types/pin';
import { Box, Text } from 'gestalt';

type Props = {
  carousel_data?: CarouselPinData,
  description: string,
  pinId: string,
};

export const PinDescription = ({ carousel_data, description }: Props) => {
  let finalDescription = description;
  // dynamically return the carousel slot's description
  if (carousel_data) {
    const { carousel_slots = [], index } = carousel_data;
    if (carousel_slots[index] && carousel_slots[index].details) {
      finalDescription = carousel_slots[index].details;
    }
  }

  const carouselTitleDescriptionStyling = carousel_data
    ? {
        height: '39px',
        overflow: 'hidden',
      }
    : {};

  return (
    <Box dangerouslySetInlineStyle={{ __style: carouselTitleDescriptionStyling }} paddingY={1}>
      <Text size="sm" weight="bold">
        <TextTransformer
          text={finalDescription}
          options={{
            hashtags: {
              appendText: `${finalDescription}`,
              source: 'hashtag_pinrep',
            },
          }}
        />
      </Text>
    </Box>
  );
};

const mapStateToProps = ({ pins }, { pinId }) => ({
  carousel_data: pins[pinId] && pins[pinId].carousel_data,
});

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(mapStateToProps)(PinDescription);
